import { NumberUtils } from '@pk/powerkioskutils';

export class ViewContractCompliance {
	public contractId: string;
	public contractNum: string;
	public status: number;
	public serviceTypeId: string;
	public displayStatus: string;
	public customerId: string;
	public dbaName: string;
	public receivableTermValue: number;
	public pricingType: string;
	public firstSignedDate: string;
	public daysFromSigned: number;
	public effectiveDate: string;
	public term: number;
	public contractDate: string;
	public confirmationDate: string;
	public supplierId: string;
	public supplierName: string;
	public displayRate: number;
	public agentName: string;
	public parentName: string;
	public units: string;
	public symbol: string;
	public isOnHold: boolean;
	public isAutoSubmitted: boolean;
	public missingContract: boolean;
	public missingBillCopy: boolean;
	public missingLOA: boolean;
	public marginAboveAverage: boolean;
	public quoteDateDiffFromRateAddDate: boolean;
	public noRateAddDate: boolean;
	public ocrResultNotReady: boolean;
	public billCopyOlderThan24h: boolean;
	public billCopyNeedsManualCheck: boolean;
	public receivedContractPages: number;
	public contractAttachmentCount: number;
	public expectedContractPages: number;
	public formattedDisplayRate: string;
	public issues: { key: string; label: string; date: Date }[];

	constructor(data: any = {}) {
		Object.assign(this, data);
		this.formattedDisplayRate = `${this.symbol}${NumberUtils.rateToUnits(this.displayRate, this.units).toString()}/${this.units}`;
	}
}
